import React from "react";
import DashboardMenu from "../components/DashboardMenu";
import SEO from "../components/Seo";
import { Outlet } from "react-router-dom";

function DashboardLayout({ children }) {
  return (
    <>
      <SEO title="Dashboard" />
      <div className="flex h-screen overflow-hidden">
        <DashboardMenu />
        <div className="flex-1 h-screen overflow-auto">
          {/* <Outlet /> */}
          {children}
        </div>
      </div>
    </>
  );
}

export default DashboardLayout;
